





























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class MensajeValidacion extends Vue {
  @Prop({ default: false }) showDialog!: boolean;
  @Prop({ default: '' }) titulo!: string;
  @Prop({ default: '' }) mensaje!: string;
  @Prop() items!: string[];

  modalMensajeValidacion: boolean = false;

  @Watch('showDialog')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.modalMensajeValidacion = value;
  }

  handleAceptar(val: boolean) {
    this.$emit('modalConfirmationEmit', val);
    this.modalMensajeValidacion = false;
  }
}
